const breakpoints = {
  values: {
    xs: 0,
    sm: 738,
    md: 960,
    lg: 1024,
    xl: 1280,
    "2xl": 1536,
  },
};

export default breakpoints;
